import React from "react";
import { Link } from "react-router-dom";
import MainLogo from "../../imgs/main-logo.png";

const Logo = () => {
  return (
    <Link to="/" className="block">
      <img
        src={MainLogo}
        alt="Pancham Records"
        className="w-20 sm:w-24 md:w-40 lg:w-40 max-w-full h-auto max-h-14 sm:max-h-16 md:max-h-20 object-contain"
      />
    </Link>
  );
};

export default Logo;
